"use client";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
const StyledButton = styled(Button, {
  shouldForwardProp: (props) => props !== "loadingPosition" && props !== "isLoading"
})`
    :focus-visible {
        outline-offset: 2px;
        outline: 2px solid Highlight;
        outline: 2px solid -webkit-focus-ring-color;
    }
    &.Mui-disabled {
        color: ${(props) => props.loadingPosition === "center" ? "transparent" : null};
        .MuiCircularProgress-root {
            position: ${(props) => props.loadingPosition === "center" ? "absolute" : null};
        }
    }
    gap: ${(props) => props.isLoading ? "8px" : "0"};
`;
export {
  StyledButton
};
